import { useCallback, useEffect, useState } from "react";
import { getAdminData } from "../apis";
import { API } from "../apis/config";
import type { AdminActiveEvent } from "../interfaces/AdminEventProduct";

export function useAdminActiveEvent() {
  const [active, setActive] = useState<AdminActiveEvent | null>(null);
  const [noneActive, setNoneActive] = useState(false);
  const [loadingActive, setLoadingActive] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);

  const loadActive = useCallback(async () => {
    setLoadingActive(true);
    setLoadError(null);
    try {
      const res = await getAdminData<AdminActiveEvent | null>(
        API.ADMIN.ACTIVE_EVENT,
      );
      if (!res.isSuccess) {
        setActive(null);
        setNoneActive(false);
        setLoadError(res.message || "활성 행사 정보를 불러오지 못했습니다.");
        return;
      }
      if (res.result == null) {
        setActive(null);
        setNoneActive(true);
        return;
      }
      setActive(res.result);
      setNoneActive(false);
    } catch (err: unknown) {
      setActive(null);
      setNoneActive(false);
      setLoadError(
        err instanceof Error
          ? err.message
          : "활성 행사 조회 중 오류가 발생했습니다.",
      );
    } finally {
      setLoadingActive(false);
    }
  }, []);

  useEffect(() => {
    void loadActive();
  }, [loadActive]);

  return {
    active,
    noneActive,
    loadingActive,
    loadError,
    loadActive,
  };
}
